// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"540":"0bbb84a0","676":"5ddf3ec6"}[chunkId] + ".chunk.js";
};